import { useQuery } from '@tanstack/react-query';
import type { Seo } from '@//app/api/seo/[id]';
import { useApiBaseUrl } from '@//providers/MarketSettingsProvider';
import { FetchError, httpClientGetJson } from '../httpClient';

interface Options {
  initialData?: Seo | null;
}

const useSeo = (id?: string, options?: Options) => {
  const apiBaseUrl = useApiBaseUrl();
  const query = useQuery<Seo | null>({
    queryKey: ['seo', id],
    queryFn: async () => {
      try {
        const url = `${apiBaseUrl}/api/seo/${id}`;
        return await httpClientGetJson<Seo>(url);
      } catch (error) {
        if (error instanceof FetchError && error.status === 404) {
          return null;
        }
        throw error;
      }
    },
    enabled: !!id,
    initialData: options?.initialData,
    placeholderData: (previousData) => previousData,
    retry: (failureCount, error) => {
      if (error instanceof FetchError && error.status === 404) {
        return false;
      }
      return failureCount < 3;
    },
  });

  return query;
};

export default useSeo;
